module.exports = __webpack_public_path__ + "img/img9.9d371a1f.jpg";